import styled from 'styled-components';

export const Upload = styled.input`
  width: 1px;
  height: 1px;
  opacity: 0;
`;
